import {
    DEPARTMENT_CREATE,
    DEPARTMENT_LIST,
    DEPARTMENT_UPDATE
} from "../actions";

export function department(currentState = {}, action) {
    switch (action.type) {
        case DEPARTMENT_CREATE:
            return {
                type: action.type,
                list: currentState.list ? currentState.list.concat(action.list) : [action.list]
            }
        case DEPARTMENT_LIST:
            return currentState = action
        case DEPARTMENT_UPDATE:
            return {
                type: action.type,
                list:  currentState.list.map(current => current.id  === action.list.id ? action.list : current)
            }
        default:
            return currentState
    }
}